module.exports = __webpack_public_path__ + "img/kontent-ai-logo.dd6b53ff.svg";